import {
  Form, Schema, SelectPicker, Stack,
} from 'rsuite';
import React from 'react';
import _ from 'lodash';
import { ItemDataType } from 'rsuite/CascadeTree';
import { Carrier } from '../../api/apiTypes';

interface Tracking {
  id: string;
  trackingNumber: string;
  trackingFullNumber: string;
  trackingUrl: string;
  carrier: string;
}

interface Props {
  index: number;
  tracking: Tracking;
  carriers: Carrier[];
  onChange: (tracking: Tracking) => void;
}

function isTrackingEmpty(tracking: Tracking): boolean {
  return !_.some([
    tracking.trackingNumber,
    tracking.trackingFullNumber,
    tracking.trackingUrl,
    tracking.carrier,
  ]);
}

function isTrackingValid(tracking: Tracking): boolean {
  if (isTrackingEmpty(tracking)) {
    return true;
  }

  return !!tracking.trackingNumber && !!tracking.trackingUrl;
}

function mapCarriers(carriers: Carrier[]): ItemDataType[] {
  return carriers.map((carrier) => ({ label: carrier.identifier, value: carrier.identifier }));
}

function getTrackingNumberRule(tracking: Tracking) {
  return Schema.Types.StringType().addRule(
    () => isTrackingValid(tracking),
    'Tracking number is required.',
    true,
  );
}

function getTrackingUrlRule(tracking: Tracking) {
  return Schema.Types.StringType().addRule(
    () => isTrackingValid(tracking),
    'Tracking URL is required.',
    true,
  );
}

export default function CrossDockTrackingRow(
  {
    index,
    tracking,
    carriers,
    onChange,
  }: Props,
) {
  return (
    <Stack direction="column" alignItems="flex-start" spacing={10}>
      <h6>
        Package
        {' '}
        {index + 1}
      </h6>
      <Stack>
        <Form.Group>
          <Form.ControlLabel>
            Tracking number
          </Form.ControlLabel>
          <Form.Control
            name={`trackingNumber.${tracking.id}`}
            type="text"
            value={tracking.trackingNumber}
            onChange={(value: string) => onChange({ ...tracking, trackingNumber: value })}
            checkTrigger="none"
            rule={getTrackingNumberRule(tracking)}
          />
        </Form.Group>
        <Form.Group>
          <Form.ControlLabel>
            Full tracking number
          </Form.ControlLabel>
          <Form.Control
            name={`parcelFullNumber.${tracking.id}`}
            type="text"
            value={tracking.trackingFullNumber}
            onChange={(value: string) => onChange({ ...tracking, trackingFullNumber: value })}
          />
        </Form.Group>
        <Form.Group>
          <Form.ControlLabel>
            Tracking url
          </Form.ControlLabel>
          <Form.Control
            name={`trackingUrl.${tracking.id}`}
            type="text"
            value={tracking.trackingUrl}
            onChange={(value: string) => onChange({ ...tracking, trackingUrl: value })}
            checkTrigger="none"
            rule={getTrackingUrlRule(tracking)}
          />
        </Form.Group>
        <Form.Group>
          <Form.ControlLabel>
            Carrier
          </Form.ControlLabel>
          <Form.Control
            name={`carrierIdentification.${tracking.id}`}
            accepter={SelectPicker}
            data={mapCarriers(carriers)}
            value={tracking.carrier}
            onChange={(value: any) => onChange({ ...tracking, carrier: value })}
            searchable
          />
        </Form.Group>
      </Stack>
    </Stack>
  );
}
